<template>
<div class="chapter">
<div class="inner_page">
<p class="SP" id="ack"> </p>
<p class="FM-Head-fmh"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="CO">Thank you to Rose, my wonderful editor, for indulging me in my passion on this one. Thanks to Emily, my fabulous agent, who is always there for me.</p>
<p class="Text-Standard-tx">As always, thanks to Mark, Matt, and Jason for your love and encouragement.</p>
<p class="Text-Standard-tx">A special thank-you to the wonderful Amy Milder of Literary Lacquers for bringing my vision of the nail polish collection in this book to life.</p>
<p class="Text-Standard-tx">You can learn more about Amy and her lovely nail polishes at: <a href="http://www.etsy.com/shop/LiteraryLacquer" target="_blank">www.etsy.com/shop/LiteraryLacquer</a>.</p>
<p class="Text-Standard-tx">For details about the nail polish collection, check Amy’s shop or go to <a href="http://www.OpalCarew.com/Nailed" target="_blank">www.OpalCarew.com/Nailed</a>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?3bd1bef1